import { useRef } from 'react';

import { useDragNDropSort } from '@app/hooks/useDragNDropSort';
import CloseIcon from '@mui/icons-material/Close';
import Card from '@mui/material/Card';
import IconButton from '@mui/material/IconButton';

import { RegularText } from '@app/components/common/RegularText';

const style = {
  cursor: 'move',
  marginRight: 5,
  width: 84,
  height: 130,
};

interface MediaCardProps {
  id: number;
  text: string;
  imageSrc: string;
  index: number;
  moveCard(dragIndex: number, hoverIndex: number): void;
  deleteCard(id: number): void;
}

export const MediaCard = ({ id, text, imageSrc, index, moveCard, deleteCard }: MediaCardProps) => {
  const ref = useRef(null);
  const { handlerId, drop, isDragging, drag } = useDragNDropSort({ ref, index, id, moveCard, direction: 'column' });
  const opacity = isDragging ? 0 : 1;
  drag(drop(ref));

  const handleDelete = () => {
    deleteCard(id);
  };

  return (
    <div key={id} style={{ width: 110, height: 145, position: 'relative' }}>
      <Card ref={ref} sx={{ ...style, opacity }} data-handler-id={handlerId}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: 5,
            width: 84,
            height: 130,
            textAlign: 'center',
          }}>
          <img style={{ maxWidth: 80, maxHeight: 60, marginBottom: 10 }} src={imageSrc} alt="Logo" />
          <RegularText sx={{ fontSize: '0.6rem' }}>{text}</RegularText>
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              right: 10,
              borderRadius: 50,
              boxShadow:
                '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
            }}>
            <IconButton
              id="delete-media-item"
              onClick={handleDelete}
              size="small"
              aria-label="delete"
              sx={{ backgroundColor: '#fff' }}>
              <CloseIcon fontSize="small" sx={{ color: 'red' }} />
            </IconButton>
          </div>
        </div>
      </Card>
    </div>
  );
};
